import {css} from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

export const StyledCompornent = css`

  .c-result__ballow{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #ffffff;
    background: #360a08;
    background-size: cover;
    padding: 10px 20px;
    position: relative;
    text-align: center;
    &::before{
      content: " ";
      display: inline-block;
      border-top: solid 15px #360a08;
      border-left: solid 15px transparent;
      border-right: solid 15px transparent;
      position: absolute;
      bottom: -13px;
    }
    @media ${break_point_sp} {
      font-size: calc((50/750)*100vw);
    }
    h4{
      white-space: pre-wrap;
      sup{
        font-size: 14px;
      }
    }
    .note{
      display:flex;
      justify-content: flex-end;
      color: #ffffff;
      font-size: 12px;
      line-height: 1.3em;
    }
  }

`;
